import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useRunFixedIncomeMutation } from '@/react-query/mutations/attributions'

import { type SchemaType, schema } from './RunFixedIncomeForm.schema'

export interface RunFixedIncomeFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const RunFixedIncomeForm: React.FC<RunFixedIncomeFormProps> = ({
  children,
  onSubmit,
  ...props
}) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)

  const runFixedIncomeMutation = useRunFixedIncomeMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (_data, _e) => {
        await runFixedIncomeMutation.mutateAsync({ ..._data })
        form.reset()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
